import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { UserLoginDTO } from "./authentication.model";
import { PreserveState } from "../../store/secure-storage";
import { authService } from "./authentication.api";

const name = "authentication";

@Module({
  store,
  name,
  dynamic: true,
  namespaced: true,
  preserveState: PreserveState(name)
})
class AuthenticationModule extends VuexModule {
  public user: any = {};
  public token: string = "";

  @Mutation
  LOGGED_IN(data: any) {
    this.user = data.user;
    this.token = data.token;
  }

  @Mutation
  SET_USER(data: any) {
    this.user = data;
  }

  @Mutation
  LOGOUT() {
    this.user = {};
    this.token = "";
    localStorage.removeItem("authentication");
  }

  @Action({ commit: "LOGGED_IN", rawError: true })
  public async Login(payload: UserLoginDTO) {
    const response = await authService.login(payload);
    return response.data;
  }

  // @Action({ commit: 'LOGGED_IN', rawError: true })
  // public async Register(payload: RegisterModel) {
  //   const response = await Regist(payload);
  //   return response.data;
  // }

  @Action({ commit: "SET_USER" })
  public async verifyToken() {
    const response = await authService.verifyToken();
    return response.data;
  }
}

export const authenticationStore = getModule(AuthenticationModule);
